module.exports = __webpack_public_path__ + "img/europe-map.91666407.svg";